import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingEngineeringUseCasePage } from "../components/marketing/MarketingEngineeringUseCasePage";

export const Route = createFileRoute("/use-cases/engineering")({
  head: () => marketingHead("/use-cases/engineering"),
  component: MarketingEngineeringUseCasePage,
});
